import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus'
import Icon from 'src/components/Icon'
import { useSchedulePostForm } from 'src/hook/useSchedulePostForm'
import i18n from 'src/i18n'

const PublishCallToAction = () => {
  const { formData } = useSchedulePostForm()

  return (
    <>
      <span className="_d-none _d-md-block" data-test="publish-call-to-action">
        {formData.pubDate && formData.scheduledPubTimeZoneId
          ? i18n.t('modals.schedule_posts.buttons.schedule')
          : i18n.t('input_publish.button_publish')}
      </span>
      <Icon icon={faPlus} className="_d-md-none" />
    </>
  )
}

export default PublishCallToAction
